// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__specialtyWrap--Q8rXa {\n  margin-top: 0;\n}\n.s-module__subStepWrap--rkFS8 > div {\n  margin-top: 0 !important;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/InvitedProviderOnboarding/SetupServices/s.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEA;EAEI,wBAAA;AADJ","sourcesContent":[".specialtyWrap {\n  margin-top: 0;\n}\n\n.subStepWrap {\n  > div {\n    margin-top: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"specialtyWrap": "s-module__specialtyWrap--Q8rXa",
	"subStepWrap": "s-module__subStepWrap--rkFS8"
};
export default ___CSS_LOADER_EXPORT___;
